"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFocus = void 0;
var _react = require("react");
const useFocus = () => {
  const htmlElRef = (0, _react.useRef)(null);
  const setFocus = () => {
    //we need a timeout to account for the element's transition time
    //not visible -> visible, otherwise we cannot focus it
    setTimeout(() => {
      htmlElRef.current && htmlElRef.current.focus();
    }, 300);
  };
  return [htmlElRef, setFocus];
};
exports.useFocus = useFocus;